import Image from 'next/image';
import PropTypes from 'prop-types';

import { staticMediaStoreBaseURL } from '@/config/common';
import { useIsMobile } from '@/helpers/screenResolutionHelper';

const RibbonButton = ({ buttonText, onClick }) => {
  const [isMobile] = useIsMobile();
  return (
    <button
      className={`group flex items-center justify-center gap-4 px-4 py-1 md:px-8 md:py-2 tracking-wider rounded-full text-white font-google-basic font-medium uppercase tracking-[0.2em] transition-all duration-300 hover:scale-105 active:scale-95 bg-list shadow-lg hover:shadow-xl`}
      onClick={onClick}
    >
      <span className='text-sm sm:text-base'>{buttonText}</span>
      <Image
        alt='arrow icon'
        className='transform rotate-180'
        height={isMobile ? 4 : 10}
        width={isMobile ? 6 : 14}
        src={`${staticMediaStoreBaseURL}/icons/back.svg`}
        style={{
          width: isMobile ? '6px' : '14px',
          height: isMobile ? '4px' : '10px',
          objectFit: 'contain'
        }}
      />
    </button>
  );
};

export default RibbonButton;
RibbonButton.propTypes = {
  buttonText: PropTypes.string,
  onClick: PropTypes.func
};
